import React, { PropTypes } from "react";
import { connect } from "react-redux";
import actions from "actions";
import constants from "constants";
import { UserItem } from "components/Admin/User/List/UserItem";
import axios from "axios";
import FileSaver from "file-saver";
const {} = actions;

const titles = {
  numbering: "#",
  name: "NAME",
  email: "EMAIL",
  user_type: "HCP",
  county: "COUNTY",
  hospital: "HOSPITAL",
};

const { API_WEBINARS_VIEWED_USERS, API_WEBINARS_USERS } = constants;

class UsersPopup extends React.Component {
  downloadCsvFile = (type) => {
    axios
      .get(
        `${API_WEBINARS_USERS}?id=${this.props.popupProps.id}&statistic_type=${type}`,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        var effectiveFileName = "webinar_users.csv";
        FileSaver.saveAs(response.data, effectiveFileName);
      })
      .catch((error) => {});
  };

  userItem = (user, index) => (
    <tr key={user.id}>
      <td>{index + 1}</td>
      <td>
        {user.first_name} {user.last_name}
      </td>
      <td>{user.email}</td>
      <td>{user.user_type}</td>
      <td>{user.county}</td>
      <td>{user.hospital}</td>
    </tr>
  );

  render() {
    const { popupProps } = this.props;
    return (
      <div className="admin_user_table admin_table">
        <table>
          <tr>
            {Object.keys(titles).map((value) => (
              <th key={value}>{titles[value]}</th>
            ))}
          </tr>
          {this.props.users.map((user, index) => this.userItem(user, index))}
        </table>
        {popupProps &&
        (popupProps.type === "attended" || popupProps.type === "viewed") ? (
          <button
            onClick={() => this.downloadCsvFile(popupProps.type)}
            className="btn-download-csv"
          >
            download CSV file
          </button>
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  popupProps: state.modal.modalContentProps.additional,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UsersPopup);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/UsersPopup.js